import React from 'react';
import { aboutFGC } from '../data/content';

export default function AboutFGC() {
  return (
    <section id="about" className="relative py-24 lg:py-36">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <p className="sec-num text-sm tracking-[0.3em] uppercase" data-reveal>/ 02</p>
          <p className="mt-6 text-[13px] tracking-[0.24em] uppercase text-[#7a7369]" data-reveal style={{ '--reveal-delay': '80ms' }}>{aboutFGC.eyebrow}</p>
          <h2 className="mt-8 font-serif text-[32px] lg:text-[44px] leading-[1.05] tracking-[-0.01em] text-[#2E2C28] font-light" data-reveal style={{ '--reveal-delay': '160ms' }}>
            An operator with real-life experience,<br />not just <span className="italic text-[#B5876C]">theory.</span>
          </h2>
        </div>

        <div className="lg:col-span-8 lg:pl-8">
          <blockquote className="relative" data-reveal style={{ '--reveal-delay': '80ms' }}>
            <span aria-hidden className="absolute -left-4 -top-6 font-serif text-[120px] leading-none text-[#B5876C]/25 select-none">“</span>
            <p className="font-serif italic text-2xl lg:text-3xl leading-[1.35] text-[#2E2C28] font-light">
              {aboutFGC.quote}
            </p>
          </blockquote>
          <div className="mt-12 border-l-2 border-[#B5876C] pl-6 max-w-2xl" data-reveal style={{ '--reveal-delay': '240ms' }}>
            <p className="text-base lg:text-lg leading-relaxed text-[#4a463f] font-light">
              {aboutFGC.body}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
